import React from 'react';
export var CircleLoader = function (_a) {
    var isLoading = _a.isLoading, _b = _a.className, className = _b === void 0 ? '' : _b, width = _a.width;
    return (React.createElement(React.Fragment, null, isLoading && (React.createElement("div", { className: "sk-fading-circle " + className, style: {
            width: width ? width + "px !important" : '20px',
            height: width ? width + "px !important" : '20px'
        } },
        React.createElement("div", { className: "sk-circle1 sk-circle" }),
        React.createElement("div", { className: "sk-circle2 sk-circle" }),
        React.createElement("div", { className: "sk-circle3 sk-circle" }),
        React.createElement("div", { className: "sk-circle4 sk-circle" }),
        React.createElement("div", { className: "sk-circle5 sk-circle" }),
        React.createElement("div", { className: "sk-circle6 sk-circle" }),
        React.createElement("div", { className: "sk-circle7 sk-circle" }),
        React.createElement("div", { className: "sk-circle8 sk-circle" }),
        React.createElement("div", { className: "sk-circle9 sk-circle" }),
        React.createElement("div", { className: "sk-circle10 sk-circle" }),
        React.createElement("div", { className: "sk-circle11 sk-circle" }),
        React.createElement("div", { className: "sk-circle12 sk-circle" })))));
};
